import { useTranslate } from '@tolgee/react';
import { Tooltip } from 'antd';
import Link from 'next/link';
import { useState } from 'react';
import styled from 'styled-components';

import { SettingsSvg } from '../../../assets/icons';
import theme from '../../../assets/theme';
import useAccessBadge from '../../../hooks/useAccessBadge';
import useRouterMatch from '../../../hooks/useRouterMatch';
import useTenantUsers from '../../../hooks/useTenantUsers';
import metrics from '../../../services/metrics';
import { zIndexes } from '../../../utils/zIndexes';
import { Button } from '../../_atoms/Button';
import { IconWrapper } from '../../_atoms/IconWrapper';
import UserProfileCircle from '../../_atoms/UserProfileCircle';
import InvitationModal from '../../_organisms/InvitationModal/InvitationModal';
import { ProfileCircle } from '../../ProfileCircle';
const MAX_USERS = 5;
const USERS_WHEN_MAX = 3;
const TenantUsers = () => {
  const { tenantId } = useRouterMatch();
  const { users, isLoading } = useTenantUsers();
  const { t } = useTranslate();
  const { accessBadge: userAccessBadge } = useAccessBadge();
  const isAdmin = userAccessBadge?.role === 'Admin';
  const [showInviteModal, setShowInviteModal] = useState(false);
  return (
    <Container>
      <InvitationModal
        onDone={() => setShowInviteModal(false)}
        role="Member"
        title={t('Invite members')}
        open={showInviteModal}
      />
      {users &&
        users
          .slice(0, users.length > MAX_USERS ? USERS_WHEN_MAX : MAX_USERS)
          .map(user => (
            <WorkSpaceUserItem key={user.id}>
              <UserProfileCircle userName={user.username} />
            </WorkSpaceUserItem>
          ))}
      {users && users.length > MAX_USERS && (
        <Tooltip
          title={users
            ?.slice(USERS_WHEN_MAX, users.length)
            .map(u => `${u.username}`)
            .join(', ')}
        >
          <MaxuserCircle>{`+${users.length - USERS_WHEN_MAX}`}</MaxuserCircle>
        </Tooltip>
      )}

      {!isLoading && isAdmin && (
        <Tooltip title={t('Invite members')}>
          <MaxuserCircle
            onClick={() => {
              metrics.getLogger().logEvent('InviteMembers', { from: 'workspacepage' });
              setShowInviteModal(true);
            }}
          >{`+`}</MaxuserCircle>
        </Tooltip>
      )}
      {!isLoading && !isAdmin && (
        <Tooltip
          title={t(
            'Only admins can invite new members. Expecting admin access? Reach out to support and we’ll help.',
          )}
          placement="bottom"
        >
          <MaxuserCircle
            style={{ opacity: 0.5, cursor: 'not-allowed' }}
          >{`+`}</MaxuserCircle>
        </Tooltip>
      )}
      {users && (
        <Link href={`/${tenantId}/profile#workspace`}>
          <a style={{ marginLeft: 5 }}>
            <Button
              height={'42px'}
              width={'auto'}
              styles={{
                color: theme.colors.black,
                backgroundColor: 'white',
                paddingLeft: 16,
                paddingRight: 10,
                boxShadow: theme.effects.floatingCreatorElementShadow,
              }}
              type="secondary"
              icon={
                <IconWrapper height="16px" width="16px">
                  <SettingsSvg />
                </IconWrapper>
              }
            ></Button>
          </a>
        </Link>
      )}
    </Container>
  );
};
const MaxuserCircle = styled(ProfileCircle)`
  color: black;
  font-weight: 600;
  margin-left: -15px;
  background-color: lightgray;
  z-index: ${zIndexes('WORKSPACE_MAX_USERS_CIRCLE')};
`;
const Container = styled.div`
  display: flex;
  padding-left: 20px;
  align-items: center;
`;
const WorkSpaceUserItem = styled.div`
  margin-left: -15px;
`;
export default TenantUsers;
